module.exports = new __parcel__URL__("discovery_prompt_no_interests.2c39a848.svg").toString();